import { defineMessages } from "react-intl";

const accessTypes = defineMessages({
  stairs: { id: "listing.access_types.stairs", defaultMessage: "Stairs" },
  elevator: { id: "listing.access_types.elevator", defaultMessage: "Elevator" },
  groundFloor: {
    id: "listing.access_types.ground_floor",
    defaultMessage: "Ground Floor",
  },
  freightElevator: {
    id: "listing.access_types.freight_elevator",
    defaultMessage: "Freight Elevator",
  },
});

const accessTypesList = [
  { key: "stairs", label: accessTypes.stairs },
  { key: "elevator", label: accessTypes.elevator },
  { key: "ground_floor", label: accessTypes.groundFloor },
  { key: "freight_elevator", label: accessTypes.freightElevator },
];

export default accessTypesList;
